import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInitializeService {
  azureSettings: any;
  constructor(@Inject('BASE_URL') private baseUrl: string) { }

  azureSettingsLoader(): Promise<void> {
    return new Promise((resolve, reject) => {
      fetch(`${this.baseUrl}api/common/getAzureSettings`)
        .then(res => res.json())
        .then(json => {
          this.azureSettings = json;
          resolve();
        })
        .catch(err => {
          console.error("Failed to load Azure settings:", err);
          reject(err);
        });
    });
  }

  getAzureSettings() {
    return this.azureSettings;
  }
}
